import { Button, Level } from 'react-bulma-components';

import React from 'react';

const Group = ({ children, ...props }) => {
  return (
    <div className="columns is-multiline">
      {children?.map((child, index) => {
        //console.log(`Child${index}: ${child.type.name}`)
        if (React.isValidElement(child)) {
          return  <div className="column" key={index}>{React.cloneElement(child, { group: { index: index, members: children.length}})}</div>
        }
        else {
          return '';
        }
      })}
    </div>
  )
/*   return (
    <Level breakpoint="mobile">
    <Level.Side align="left">
      {children.map(child => {
        return (
          <Level.Item>
            {child}
          </Level.Item>
        )
      })}
    </Level.Side>
  </Level>
  ); */
}
export default Group;



